import actions from "../actions";

const agreementflow = (state = {}, action) => {
  switch (action.type) {
    case actions.SET_AGREEMENT_WORKFLOW:
      return action.payload;
    default:
      return state;
  }
};

export default agreementflow;
